import * as React from "react";
const Directory = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.54686 2.84005C8.4403 3.64307 7.7207 4.9468 7.7207 6.4186C7.7207 8.85893 9.69898 10.8372 12.1393 10.8372C14.5796 10.8372 16.5579 8.85893 16.5579 6.4186C16.5579 3.97828 14.5796 2 12.1393 2C12.1154 2 12.0916 2.00019 12.0677 2.00057C12.0451 2.00019 12.0224 2 11.9996 2C11.0753 2 10.2242 2.31353 9.54686 2.84005Z"
      fill="black"
    />
    <path
      d="M12.1397 12.2327C9.98763 12.2327 8.00482 12.7219 6.53552 13.5484C5.08812 14.3626 4.00012 15.5965 4.00012 17.1164L4.00006 17.2112C3.99901 18.2919 3.99769 19.6483 5.18747 20.6172C5.77302 21.0941 6.59218 21.4332 7.69891 21.6572C8.80873 21.8819 10.2552 22.0001 12.1397 22.0001C12.2186 22.0001 12.2968 21.9999 12.3742 21.9995C12.416 21.9999 12.458 22.0001 12.5 22.0001C12.6468 22.0001 12.7925 21.9976 12.9372 21.9926C14.4392 21.9633 15.6326 21.8491 16.5804 21.6572C17.6871 21.4332 18.5063 21.0941 19.0918 20.6172C20.2816 19.6483 20.2803 18.2919 20.2793 17.2112L20.2792 17.1164C20.2792 15.5965 19.1912 14.3626 17.7438 13.5484C16.2745 12.7219 14.2917 12.2327 12.1397 12.2327Z"
      fill="black"
    />
  </svg>
);
export default Directory;
